export default __webpack_public_path__ + "static/media/021-insignia.05ac5315.png";